import axios from "axios";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { faFacebook, faInstagram, faTiktok } from "@fortawesome/free-brands-svg-icons";
import { FacebookShareButton } from "react-share";
import { toast } from "react-toastify";

function VideoPlayList() {
  const navigate = useNavigate();
  const [showShareOptions, setShowShareOptions] = useState(false);
  const TOKEN = localStorage.getItem("adminToken");
  const user_id = localStorage.getItem("userId");

  const [filterKey, setFilterKey] = useState("");
  const [sortKey, setSortKey] = useState("");
  const [videolist, getVideosData] = useState([]);
  const [playVideoId, setPlayVideoId] = useState("");
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [videocommentslist, getVideosCommentsData] = useState([]);
  const [CommentParentID] = useState(0);
  const [comment_holder_name, setCommentHoldername] = useState([]);
  const [message, setComment] = useState("");
  const [video_id, setVideoId] = useState("");
  const [isLiked, setIsLiked] = useState(false);
  const [isUnLiked, setIsUnLiked] = useState(false);
  const [likedById, getLikedById] = useState([]);
  const [video_like_status, getVideoLikeStatus] = useState(0);
  const [video_unlike_status, getVideoUnlike] = useState(0);
  const [editingCommentId, setEditingCommentId] = useState(null);
  const [editedMessage, setEditedMessage] = useState("");
  const [replyingToCommentId, setReplyingToCommentId] = useState(null);
  const [replyMessage, setReplyMessage] = useState("");
  const [currentCommentId, setCurrentCommentId] = useState(null);
  const [subCommentData, setSubCommentData] = useState(null);
  const [count, setCount] = useState({});
  const [subCommentDisplayCount, setSubCommentDisplayCount] = useState({});
  const [subCommentViewMode, setSubCommentViewMode] = useState({});
  const [userGender, setUserGender] = useState(null);
  const SUB_COMMENT_THRESHOLD = 3;

  const parent_id = "0";
  const API_URL = `${process.env.REACT_APP_API_URL}/video/getlist/?sort_key=${filterKey}&order_key=${sortKey}`;

  useEffect(() => {
    if (!user_id) {
      window.location.href = "/login";
    } else {
      getUserInfoByUserId(user_id);
    }
  }, [user_id]);




  const getUserInfoByUserId = async (UserID) => {
    const GETUSERINFO_API_URL = `${process.env.REACT_APP_API_URL}/users/${UserID}`;
    try {
      const res = await fetch(GETUSERINFO_API_URL);
      const data = await res.json();
      setCommentHoldername(data.data.profile_pic);
      setUserGender(data.data.gender || null);
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };

  const fetchVideosData = async () => {
    try {
      const response = await fetch(API_URL);
      const res = await response.json();
      getVideosData(res["data"]);
      if (res.data.length) {
        const vId = getVideoIdFromUrl(res.data[0].url);
        setPlayVideoId(`https://www.youtube.com/embed/${vId}`);
        setSelectedVideo(res.data[0]);
        setVideoId(res.data[0].id);
        fetchVideosCommentsData(res.data[0].id);
      } else {
        setPlayVideoId("https://www.youtube.com/embed/dQw4w9WgXcQ");
        setSelectedVideo(null);
        setVideoId("");
      }
    } catch (error) {
      console.error("Error fetching videos data:", error);
      if (error.response?.status === 401) {
        navigate("/login");
      }
    }
  };

  useEffect(() => {
    fetchVideosData();
  }, [filterKey, sortKey]);

  const getVideoIdFromUrl = (url) => {
    try {
      const urlObject = new URL(url);
      const videoId = urlObject.searchParams.get("v");
      return videoId || null;
    } catch (error) {
      console.error("Error extracting video ID:", error);
      return null;
    }
  };

  const fetchVideosCommentsData = (playVideoId) => {
    const VIDEO_COMMENTS_API_URL = `${process.env.REACT_APP_API_URL}/commentsvideo/?video_id=${playVideoId}&parent_id=${CommentParentID}`;
    fetch(VIDEO_COMMENTS_API_URL)
      .then((res) => res.json())
      .then((res) => {
        getVideosCommentsData(res.data);
      });
  };

  const handleVideoPlay = (e, videolistData) => {
    const vId = getVideoIdFromUrl(videolistData.url);
    setPlayVideoId(`https://www.youtube.com/embed/${vId}`);
    setSelectedVideo(videolistData);
    fetchVideosCommentsData(videolistData.id);
    setVideoId(videolistData.id);
  };

  const handleCommentSubmit = () => {
    if (message.trim() !== "") {
      const commentData = {
        video_id: video_id,
        user_id: user_id,
        message: message,
        parent_id: parent_id,
      };
      axios
        .post(`${process.env.REACT_APP_API_URL}/commentsvideo/add`, commentData, {
          headers: { Authorization: `Bearer ${TOKEN}` },
        })
        .then(() => {
          fetchVideosCommentsData(video_id);
          setComment("");
        })
        .catch((error) => {
          console.error("Error adding comment:", error);
        });
    }
  };

  const handleCommentDelete = async (commentId) => {
    const confirmed = window.confirm("Are you sure you want to delete this comment?");
    if (!confirmed) return;
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/commentsvideo/delete/${commentId}`, {
        headers: { Authorization: `Bearer ${TOKEN}` },
      });
      fetchVideosCommentsData(video_id);
      fetchVideosSubCommentsData(video_id);
    } catch (error) {
      console.error("Error deleting comment:", error);
    }
  };

  const handleEditClick = (commentId, originalMessage) => {
    setEditingCommentId(commentId);
    setEditedMessage(originalMessage);
    setReplyingToCommentId(null);
  };

  const handleCancelEdit = () => {
    setEditingCommentId(null);
    setEditedMessage("");
  };

  const handleEditSubmit = (commentId) => {
    const updatedCommentData = {
      video_id: video_id,
      user_id: user_id,
      message: editedMessage,
      parent_id: parent_id,
    };
    axios
      .put(`${process.env.REACT_APP_API_URL}/commentsvideo/update/${commentId}`, updatedCommentData, {
        headers: { Authorization: `Bearer ${TOKEN}` },
      })
      .then(() => {
        fetchVideosCommentsData(video_id);
        fetchVideosSubCommentsData(video_id);
        setEditingCommentId(null);
        setEditedMessage("");
      })
      .catch((error) => {
        console.error("Error editing comment:", error);
      });
  };

  const handleReplyClick = (commentId) => {
    setReplyingToCommentId(commentId);
    setEditingCommentId(null);
  };

  const handleReplySubmit = () => {
    if (replyMessage.trim() !== "") {
      const replyData = {
        video_id: video_id,
        user_id: user_id,
        message: replyMessage,
        parent_id: replyingToCommentId,
      };
      axios
        .post(`${process.env.REACT_APP_API_URL}/commentsvideo/add`, replyData, {
          headers: { Authorization: `Bearer ${TOKEN}` },
        })
        .then(() => {
          setReplyingToCommentId(null);
          setReplyMessage("");
          fetchVideosCommentsData(video_id);
          fetchVideosSubCommentsData(video_id);
        })
        .catch((error) => {
          console.error("Error adding reply:", error);
        });
    }
  };

  const handleLikeClick = async () => {
    if (!video_id) {
      alert("Please select a video to like.");
      return;
    }
    const wasLiked = isLiked;
    try {
      // Optimistic update
      setIsLiked(!wasLiked);
      setIsUnLiked(false); // Reset unlike state
      if (wasLiked) {
        getVideoLikeStatus(wasLiked ? video_like_status - 1 : video_like_status + 1);

      }

      const data = {
        video_id: video_id,
        user_id: user_id,
        like: wasLiked ? "0" : "1", // Toggle like
        unlike: "0",
      };
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/likeunlike/add`,
        data,
        { headers: { Authorization: `Bearer ${TOKEN}` } }
      );
      if (response.status !== 200 && response.status !== 201) {
        // Revert optimistic update on failure
        setIsLiked(wasLiked);
        getVideoLikeStatus(wasLiked ? video_like_status + 1 : video_like_status - 1);
        throw new Error("API request failed");
      }
      getVideoLikeUnlikeInfo(); // Refresh data
    } catch (error) {
      console.error("Error toggling like:", error.response?.status, error.response?.data);
      alert("Failed to update like. Please try again.");
      setIsLiked(wasLiked); // Revert on error
      getVideoLikeStatus(wasLiked ? video_like_status + 1 : video_like_status - 1);
    }
  };

  const handleUnlike = async () => {
    if (!video_id) {
      alert("Please select a video to unlike.");
      return;
    }
    const wasUnLiked = isUnLiked;
    try {
      // Optimistic update
      setIsUnLiked(!wasUnLiked);
      setIsLiked(false); // Reset like state
      if (wasUnLiked) {
        getVideoUnlike(wasUnLiked ? video_unlike_status - 1 : video_unlike_status + 1);
      }

      const data = {
        video_id: video_id,
        user_id: user_id,
        like: "0",
        unlike: wasUnLiked ? "0" : "1", // Toggle unlike
      };
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/likeunlike/add`,
        data,
        { headers: { Authorization: `Bearer ${TOKEN}` } }
      );
      if (response.status !== 200 && response.status !== 201) {
        // Revert optimistic update on failure
        setIsUnLiked(wasUnLiked);
        getVideoUnlike(wasUnLiked ? video_unlike_status + 1 : video_unlike_status - 1);
        throw new Error("API request failed");
      }
      getVideoLikeUnlikeInfo(); // Refresh data
    } catch (error) {
      console.error("Error toggling unlike:", error.response?.status, error.response?.data);
      alert("Failed to update unlike. Please try again.");
      setIsUnLiked(wasUnLiked); // Revert on error
      getVideoUnlike(wasUnLiked ? video_unlike_status + 1 : video_unlike_status - 1);
    }
  };

  const getVideoLikeUnlikeInfo = async () => {
    try {
      const config = { headers: { Authorization: `Bearer ${TOKEN}` } };
      const likeResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}/likeunlike/list/?key=like&video_id=${video_id}`,
        config
      );
      const unlikeResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}/likeunlike/list/?key=unlike&video_id=${video_id}`,
        config
      );
      getVideoLikeStatus(likeResponse.data.data.count);
      getLikedById(likeResponse.data.data.list);
      getVideoUnlike(unlikeResponse.data.data.count);
      setIsLiked(likeResponse.data.data.list.some((item) => item.user_id === user_id));
      setIsUnLiked(unlikeResponse.data.data.list.some((item) => item.user_id === user_id));
    } catch (error) {
      console.error("Error fetching like/unlike info:", error);
    }
  };

  useEffect(() => {
    if (video_id) getVideoLikeUnlikeInfo();
  }, [video_id]);

  const fetchVideosSubCommentsData = (commmentId) => {
    const VIDEO_COMMENTS_API_URL = `${process.env.REACT_APP_API_URL}/commentsvideo/?video_id=${video_id}&parent_id=${commmentId}`;
    fetch(VIDEO_COMMENTS_API_URL)
      .then((res) => res.json())
      .then((res) => {
        setSubCommentData(res.data);
        setCount((prevCounts) => ({
          ...prevCounts,
          [commmentId]: res?.data?.length || 0,
        }));
      });
  };

  const handleSubComment = (e, commentId) => {
    e.preventDefault();
    setCurrentCommentId((prevId) => (prevId === commentId ? null : commentId));
    fetchVideosSubCommentsData(commentId);
    setSubCommentViewMode((prevMode) => {
      const newMode = !prevMode[commentId];
      if (newMode) {
        setSubCommentDisplayCount((prevCount) => ({
          ...prevCount,
          [commentId]: SUB_COMMENT_THRESHOLD,
        }));
      }
      return { ...prevMode, [commentId]: newMode };
    });
  };

  const handleViewToggle = (commentId) => {
    setSubCommentViewMode((prevMode) => {
      const newMode = !prevMode[commentId];
      setSubCommentDisplayCount((prevCount) => ({
        ...prevCount,
        [commentId]: newMode ? subCommentData?.length : SUB_COMMENT_THRESHOLD,
      }));
      return { ...prevMode, [commentId]: newMode };
    });
  };

  const handleShareButtonClick = () => {
    setShowShareOptions(!showShareOptions);
  };

  const handleSortChange = (e) => {
    setSortKey(e.target.value);
    fetchVideosData();
  };

  const handleFilterChange = (event) => {
    setFilterKey(event.target.value);
    fetchVideosData();
  };



  return (
    <section className="video-playlist-sec secpd70">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-xl-9 left_content_wrap">
            <div className="video-playbox">
              <div className="vp-videowrap">
                <iframe
                  className="w-100"
                  src={playVideoId || "https://www.youtube.com/embed/dQw4w9WgXcQ"}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
              <div className="vp-content">
                <div className="vp_top_bar">
                  <div className="vp_top_left">
                    <p>{selectedVideo?.title}</p>
                    <div className="btn-group">
                      <button
                        type="button"
                        className={`video-btn ${isLiked && userGender === "male" ? "video-btn--liked-male" : ""}`}
                        onClick={handleLikeClick}
                        disabled={!video_id}
                        aria-label={isLiked ? "Unlike video" : "Like video"}
                      >
                        <img
                          src={isLiked ? "./img/thumbs-up-blue.png" : "./img/thum-up.png"}
                          className="video-btn__icon"
                          alt=""
                        />
                        <span className="video-btn__count">{video_like_status} {video_like_status === 1 ? "Like" : "Likes"}</span>
                      </button>
                      <button
                        type="button"
                        className={`video-btn ${isUnLiked && userGender === "male" ? "video-btn--liked-male" : ""}`}
                        onClick={handleUnlike}
                        disabled={!video_id}
                        aria-label={isUnLiked ? "Dislike video" : "Remove dislike"}
                      >
                        <img
                          src={isUnLiked ? "./img/thum-down-blue.png" : "./img/thum-down.png"}
                          className="video-btn__icon"
                          alt=""
                        />
                        <span className="video-btn__count">{video_unlike_status} {video_unlike_status === 1 ? "Dislike" : "Dislikes"}</span>
                      </button>
                    </div>
                    <div className="share-buttons">
                      <button
                        type="button"
                        className="btn btn-light rounded-5"
                        onClick={handleShareButtonClick}
                      >
                        <img src="./img/share.png" alt="" /> Share
                      </button>
                      {showShareOptions && (
                        <div className="share-options">
                          <FacebookShareButton
                            url={playVideoId}
                            quote={selectedVideo?.title}
                            className="btn btn-primary"
                          >
                            <FontAwesomeIcon icon={faFacebook} />
                          </FacebookShareButton>
                          <a
                            href={`https://www.instagram.com/share?url=${playVideoId}`}
                            className="btn btn-primary"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <FontAwesomeIcon icon={faInstagram} />
                          </a>
                          <button onClick={() => { }} className="btn btn-primary">
                            <FontAwesomeIcon icon={faTiktok} />
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="vp_top_right">
                    <ul>
                      <li>
                        <img src="./img/fa-clock.png" alt="Clock" />{" "}
                        {selectedVideo?.createdAt
                          ? moment(selectedVideo.createdAt).format("h:mm A")
                          : "Time not available"}
                      </li>
                      <li>
                        <img src="./img/fa-calendar.png" alt="Calendar" />{" "}
                        {selectedVideo?.createdAt
                          ? moment(selectedVideo.createdAt).format("MMMM D, YYYY")
                          : "Date not available"}
                      </li>
                    </ul>
                  </div>
                </div>
                <p>{selectedVideo?.title}</p>
                <hr className="form-divider" />
                <div className="comment-wrap">
                  <img src="./img/comment.png" alt="" className="leftImg" />
                  <input
                    type="text"
                    placeholder="Add a comment...."
                    className="form-control"
                    name="message"
                    value={message}
                    onChange={(e) => setComment(e.target.value)}
                  />
                  <button className="sendbtn" onClick={handleCommentSubmit}>
                    <svg
                      width="29"
                      height="24"
                      viewBox="0 0 29 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.678223 24L28.6782 12L0.678223 0V9.33333L20.6782 12L0.6782 14.6667V24Z"
                        fill="#1167C9"
                      />
                    </svg>
                  </button>
                </div>
                <br />
                {videocommentslist?.map((comment, index) => (
                  <div className="card-body p-4" key={index}>
                    <div className="row">
                      <div className="col">
                        <div className="d-flex flex-start">
                          <img
                            className="rounded-circle shadow-1-strong me-3"
                            src="https://mdbcdn.b-cdn.net/img/Photos/Avatars/img%20(10).webp"
                            alt="avatar"
                            width="40"
                            height="40"
                          />
                          <div
                            className="flex-grow-1 flex-shrink-1"
                            style={{ fontSize: "16px" }}
                          >
                            <div>
                              <div className="d-flex justify-content-between align-items-center">
                                <p className="mb-1" style={{ fontSize: "17px" }}>
                                  {comment?.User?.fname} {comment?.User?.lname}
                                  <span className="small">
                                    {" "}
                                    - {moment(comment.createdAt).fromNow()}
                                  </span>
                                </p>
                              </div>
                              <p className="small mb-0">{comment.message}</p>
                            </div>
                            {!editingCommentId || editingCommentId !== comment.id ? (
                              <>
                                {comment.user_id === user_id && (
                                  <a
                                    href="#!"
                                    className="small mb-0 link-grey"
                                    style={{ color: "#aaa" }}
                                    onClick={() =>
                                      handleEditClick(comment.id, comment.message)
                                    }
                                  >
                                    Edit
                                  </a>
                                )}
                              </>
                            ) : (
                              <div>
                                <textarea
                                  className="form-control"
                                  name="message"
                                  value={editedMessage}
                                  onChange={(e) => setEditedMessage(e.target.value)}
                                />
                                <br />
                                <button
                                  className="btn btn-info my-2 mx-2"
                                  onClick={() => handleEditSubmit(comment.id)}
                                >
                                  Update
                                </button>
                                <button
                                  className="btn btn-primary my-2"
                                  onClick={handleCancelEdit}
                                >
                                  Cancel
                                </button>
                              </div>
                            )}
                            {comment.user_id === user_id ? (
                              <>
                                <a
                                  className="small mb-0 link-grey"
                                  href="#"
                                  onClick={() => handleCommentDelete(comment.id)}
                                >
                                  Delete
                                </a>{" "}
                                <a
                                  href="#"
                                  className="small mb-0 link-grey"
                                  onClick={() =>
                                    handleEditClick(comment.id, comment.message)
                                  }
                                >
                                  Edit
                                </a>
                              </>
                            ) : (
                              <a
                                href="#"
                                className="small mb-0 link-grey"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleReplyClick(comment.id);
                                }}
                              >
                                Reply
                              </a>
                            )}
                            {replyingToCommentId === comment.id && (
                              <div>
                                <textarea
                                  className="form-control link-grey"
                                  name="replyMessage"
                                  value={replyMessage}
                                  onChange={(e) => setReplyMessage(e.target.value)}
                                />
                                <br />
                                <button
                                  className="small mb-0 link-grey"
                                  onClick={handleReplySubmit}
                                >
                                  Reply
                                </button>
                              </div>
                            )}
                            <a
                              href="#!"
                              className="small mb-0 link-grey"
                              onClick={(e) => handleSubComment(e, comment.id)}
                            >
                              View {count?.[comment.id] || 0} comments
                            </a>
                            {currentCommentId === comment.id && (
                              <div>
                                {subCommentData
                                  ?.slice(
                                    0,
                                    subCommentDisplayCount[comment.id] ||
                                    SUB_COMMENT_THRESHOLD
                                  )
                                  .map((subComment) => (
                                    <div
                                      className="d-flex flex-start mt-4"
                                      key={subComment.id}
                                    >
                                      <a href="#" className="me-3">
                                        <img
                                          className="rounded-circle shadow-1-strong"
                                          src="https://mdbcdn.b-cdn.net/img/Photos/Avatars/img%20(11).webp"
                                          alt="avatar"
                                          width="40"
                                          height="40"
                                        />
                                      </a>
                                      <div
                                        className="flex-grow-1 flex-shrink-1"
                                        style={{ fontSize: "16px" }}
                                      >
                                        <div>
                                          <div className="d-flex justify-content-between align-items-center">
                                            <p
                                              className="mb-1"
                                              style={{ fontSize: "17px" }}
                                            >
                                              {subComment?.User?.fname}{" "}
                                              {subComment?.User?.lname}
                                              <span className="small">
                                                {" "}
                                                -{" "}
                                                {moment(
                                                  subComment.createdAt
                                                ).fromNow()}
                                              </span>
                                            </p>
                                          </div>
                                          <p className="small mb-0">
                                            {subComment.message}
                                          </p>
                                          {!editingCommentId ||
                                            editingCommentId !== subComment.id ? (
                                            <>
                                              {subComment.user_id ===
                                                user_id && (
                                                  <a
                                                    href="#!"
                                                    className="small mb-0 link-grey"
                                                    style={{ color: "#aaa" }}
                                                    onClick={() =>
                                                      handleEditClick(
                                                        subComment.id,
                                                        subComment.message
                                                      )
                                                    }
                                                  >
                                                    Edit
                                                  </a>
                                                )}
                                            </>
                                          ) : (
                                            <div>
                                              <textarea
                                                className="form-control"
                                                name="message"
                                                value={editedMessage}
                                                onChange={(e) =>
                                                  setEditedMessage(e.target.value)
                                                }
                                              />
                                              <br />
                                              <button
                                                className="btn btn-info my-2 mx-2"
                                                onClick={() =>
                                                  handleEditSubmit(subComment.id)
                                                }
                                              >
                                                Update
                                              </button>
                                              <button
                                                className="btn btn-primary my-2"
                                                onClick={handleCancelEdit}
                                              >
                                                Cancel
                                              </button>
                                            </div>
                                          )}
                                          {subComment.user_id === user_id ? (
                                            <>
                                              <a
                                                className="small mb-0 link-grey"
                                                href="#"
                                                onClick={() =>
                                                  handleCommentDelete(
                                                    subComment.id
                                                  )
                                                }
                                              >
                                                Delete
                                              </a>{" "}
                                              <a
                                                href="#"
                                                className="small mb-0 link-grey"
                                                onClick={() =>
                                                  handleEditClick(
                                                    subComment.id,
                                                    subComment.message
                                                  )
                                                }
                                              >
                                                Edit
                                              </a>
                                            </>
                                          ) : (
                                            <a
                                              href="#"
                                              className="small mb-0 link-grey"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                handleReplyClick(subComment.id);
                                              }}
                                            >
                                              Reply
                                            </a>
                                          )}
                                          {replyingToCommentId ===
                                            subComment.id && (
                                              <div>
                                                <textarea
                                                  className="form-control"
                                                  name="replyMessage"
                                                  value={replyMessage}
                                                  onChange={(e) =>
                                                    setReplyMessage(e.target.value)
                                                  }
                                                />
                                                <br />
                                                <button
                                                  className="link-grey"
                                                  onClick={handleReplySubmit}
                                                >
                                                  Reply
                                                </button>
                                              </div>
                                            )}
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                {subCommentData?.length > SUB_COMMENT_THRESHOLD && (
                                  <a
                                    href="#"
                                    className="small mb-0 link-grey"
                                    style={{ color: "grey" }}
                                    onClick={() => handleViewToggle(comment.id)}
                                  >
                                    {subCommentViewMode[comment.id]
                                      ? "View Less"
                                      : "View More"}
                                  </a>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-xl-3 right_content_wrap">
            <div className="video-playbox side-wrap">
              Sort by:
              <br />
              <div className="sortwrap">
                <select
                  className="form-select"
                  name="sort_key"
                  value={sortKey}
                  onChange={handleSortChange}
                >
                  <option value="asc">Ascending</option>
                  <option value="desc">Descending</option>
                </select>
                <select
                  className="form-select"
                  name="filter_key"
                  value={filterKey}
                  onChange={handleFilterChange}
                >
                  <option value="title">Alphabetical Order</option>
                  <option value="id">Recently Added</option>
                </select>
              </div>
              <div className="vid-wrap">
                {videolist?.map((videolistData, key) => (
                  <div
                    className="vid-in-left-card"
                    onClick={(e) => handleVideoPlay(e, videolistData)}
                    key={key}
                  >
                    <div className="vid-img-wrap">
                      <img
                        src={`https://img.youtube.com/vi/${getVideoIdFromUrl(
                          videolistData.url
                        )}/default.jpg`}
                        alt=""
                      />
                      <a href="javascript:void(0)" className="playicon">
                        <img src="img/playicon.png" alt="" />
                      </a>
                    </div>
                    <div className="vid-content-wrap">
                      <h2>{videolistData.title}</h2>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default VideoPlayList;